"use client"

import styled from "styled-components"
import { Bar, BarChart, Cell, ResponsiveContainer } from "recharts"
import {
  Badge,
  BigValue,
  Card,
  CardHeader,
  SegBar,
  SegBarPart,
  StatGrid,
  StatLabel,
  StatValue,
  Subtitle,
  Title,
  TitleGroup,
  Unit,
} from "./primitives"

const candles = [
  { d: 0, v: 62 }, { d: 1, v: 64 }, { d: 2, v: 61 }, { d: 3, v: 66 },
  { d: 4, v: 69 }, { d: 5, v: 67 }, { d: 6, v: 71 }, { d: 7, v: 74 },
  { d: 8, v: 72 }, { d: 9, v: 77 }, { d: 10, v: 79 }, { d: 11, v: 82 },
]

const ChartWrap = styled.div`
  margin-top: 1.25rem;
  height: 6.5rem;
  width: 100%;
`

const dominance = [
  { label: "BTC", value: 54, color: "var(--color-caution)" },
  { label: "ETH", value: 17, color: "var(--color-optimal)" },
  { label: "Stables", value: 8, color: "var(--color-alert)" },
  { label: "Alts", value: 21, color: "var(--color-chart-5)" },
]

const Legend = styled.div`
  margin-top: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
`

const LegendItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.375rem;
`

const Value = styled.span`
  font-family: var(--font-mono);
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-card-foreground);
`

const Label = styled.span`
  font-size: 0.875rem;
  color: var(--color-muted-foreground);
`

export function CryptoPriceCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Bitcoin</Title>
          <Subtitle>BTC · USD</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">+6.2% 7d</Badge>
      </CardHeader>

      <div style={{ marginTop: "1rem" }}>
        <BigValue>
          $98,240<Unit> </Unit>
        </BigValue>
      </div>

      <ChartWrap>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={candles} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
            <Bar dataKey="v" radius={[3, 3, 3, 3]} isAnimationActive={false}>
              {candles.map((c, i) => (
                <Cell
                  key={i}
                  fill={
                    i > 0 && c.v < candles[i - 1].v
                      ? "var(--color-alert)"
                      : "var(--color-optimal)"
                  }
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </ChartWrap>

      <StatGrid>
        <div>
          <StatLabel>24h vol</StatLabel>
          <StatValue>$41.2B</StatValue>
        </div>
        <div>
          <StatLabel>Mkt cap</StatLabel>
          <StatValue>$1.94T</StatValue>
        </div>
        <div>
          <StatLabel>Funding</StatLabel>
          <StatValue $tone="optimal">+0.01%</StatValue>
        </div>
      </StatGrid>
    </Card>
  )
}

export function CryptoDominanceCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Market dominance</Title>
          <Subtitle>Share of total crypto cap</Subtitle>
        </TitleGroup>
      </CardHeader>

      <Legend>
        {dominance.map((d) => (
          <LegendItem key={d.label}>
            <Value>{d.value}%</Value>
            <Label>{d.label}</Label>
          </LegendItem>
        ))}
      </Legend>

      <SegBar>
        {dominance.map((d) => (
          <SegBarPart key={d.label} $width={d.value} $color={d.color} role="presentation" />
        ))}
      </SegBar>
    </Card>
  )
}

export default function CryptoCards() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <CryptoPriceCard />
      <CryptoDominanceCard />
    </div>
  )
}
